import React from "react";

const Disclaimer = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h1 className="text-2xl font-extrabold text-gray-900">Disclaimer</h1>

      <p className="mt-4 text-gray-700 leading-relaxed">
        The articles on this website are automatically generated using Minilo
        AI, based on the top 5 trending searches in the US. While we strive for
        accuracy, Minilo AI-generated content may sometimes contain errors or
        outdated information. Readers are advised to verify all information
        before relying on it.
      </p>

      <div className="mt-6 p-4 border-l-4 border-yellow-500 bg-yellow-50">
        <p className="text-gray-800 font-medium">
          Minilo AI-generated content does not constitute professional or expert
          advice. Use it at your own discretion.
        </p>
      </div>
    </div>
  );
};

export default Disclaimer;
